import React from "react";
import {
    CREATE_GROUP_CHAT,
    CLIENT_NOTICEBOARD,
    FULL_ACCESS_BUSINESS_CHAT,
    MESSAGE_CLIENTS,
    MESSAGE_EMPLOYEES,
} from "src/constants/permissions";

const styles = {
    base: {
        padding: "8px 16px",
        borderRadius: "7px",
        fontSize: "14px",
        fontWeight: 500,
        textAlign: "center",
        width: "fit-content",
    },

    variants: {
        noPermissions: {
            backgroundColor: "#FFEFCA",
            color: "#CF5300",
        },
        chatPermissions: {
            backgroundColor: "#EFE7FF",
            color: "#633FE4",
        },
        noticeboardPermission: {
            backgroundColor: "rgba(91,110,245,0.12)",
            color: "var(--calendar-text, #171A22)",
        },
        multiplePermissions: {
            backgroundColor: "#ffcef9",
            color: "#892D7E",
        },
        dashboardPermissions: {
            backgroundColor: "rgba(91,110,245,0.12)",
            color: "var(--calendar-text, #171A22)",
        },
        default: {
            backgroundColor: "#F0F0F0",
            color: "#555",
        },
    },
};

export default function ChatPermissionCard({ permissionIds }) {
    const chatPermissionIds = [FULL_ACCESS_BUSINESS_CHAT, MESSAGE_CLIENTS, MESSAGE_EMPLOYEES, CREATE_GROUP_CHAT];

    const title = () => {
        if (permissionIds.length === 0) {
            return "No Permissions";
        }
        if (permissionIds.length > 1) {
            return "Multiple Permissions";
        }
        if (permissionIds.includes(CLIENT_NOTICEBOARD)) {
            return "Noticeboard Permissions";
        }
        if (
            permissionIds.length === 1 &&
            chatPermissionIds.some(
                (id) => permissionIds.includes(id)
            )
        ) {
            return "Chat Permissions";
        }

        return "Multiple Permissions";
    };

    let variantStyle = styles.variants.default;

    if (permissionIds.length === 0) variantStyle = styles.variants.noPermissions;
    if (permissionIds.length > 1) variantStyle = styles.variants.multiplePermissions;
    if (permissionIds.length === 1 && permissionIds.includes(CLIENT_NOTICEBOARD)) {
        variantStyle = styles.variants.noticeboardPermission;
    }
    if (
        permissionIds.length === 1 &&
        chatPermissionIds.some(
            (id) => permissionIds.includes(id)
        )
    )
        variantStyle = styles.variants.chatPermissions;
    return <div style={{ ...styles.base, ...variantStyle }}>{title()}</div>;
}
